import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_PAYMENT_RESET = 'POST_PAYMENT_RESET';
export const POST_PAYMENT_LOADING = 'POST_PAYMENT_LOADING';
export const POST_PAYMENT_SUCCESS = 'POST_PAYMENT_SUCCESS';
export const POST_PAYMENT_REJECT = 'POST_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const postPaymentReset = () => ({ type: POST_PAYMENT_RESET });
export const postPaymentLoading = () => ({ type: POST_PAYMENT_LOADING });
export const postPaymentSuccess = (payload) => ({ type: POST_PAYMENT_SUCCESS, payload });
export const postPaymentReject = (payload) => ({ type: POST_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postPaymentRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/api/TypePayments`, options);
};


